// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__21iQk","detailsBorder":"styles_detailsBorder__39j4T"};